import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { ConsoleShell } from '@/features/shell/console-shell';
import { ProjectResolver } from '@/features/shell/project-resolver';

/** `/$tenant/llm-keys` — entrée « Clés de la passerelle » hors projet : redirige vers le dernier projet ouvert (lot L08). */
export const Route = createFileRoute('/$tenant/llm-keys')({ component: LlmKeysRedirect });

function LlmKeysRedirect() {
  const { tenant } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell tenantId={tenant} activeItem="llmKeys" crumbs={[{ label: t('nav.items.llmKeys') }]}>
      <ProjectResolver tenantId={tenant} section="llmKeys" />
    </ConsoleShell>
  );
}
